export enum ViewModes {
	TableView,
	ListView,
	Query,
	Template,
	Spim,
	KanbanQuery,
	InvoicingQuery
}